import React, { useEffect, useState } from "react";
import { Button, Icon } from "semantic-ui-react";

const IndentFromVehicle = (props) => {

    useEffect(() => {
    }, []);

    const handleOpenEdit = () => {
        console.log("open edit");
        console.log(props.data)
        props.agGridReact.props.openIndentModal(props.data.vehicle_availability_id);
    };

    return (
        <>
            <Button
                onClick={handleOpenEdit}
                basic
                size="mini"
                type="button"
                icon
            >
                {" "}
                <Icon name="eye" color="green" />
            </Button>
        </>
    );
}

export default IndentFromVehicle;